// extracted by mini-css-extract-plugin
module.exports = {"carouselBase":"styles_carouselBase___oC_S","carousel":"styles_carousel__jF0tm","pagination":"styles_pagination__269Is"};